import Marionette from 'backbone.marionette'
import template from 'text-loader!templates/research/researchLanding.html'

var ResearchLandingView = Marionette.ItemView.extend({
  template: template
});

export default ResearchLandingView;

